import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Control, LocalForm } from 'react-redux-form';
import { Helmet } from 'react-helmet';
import AlertDownload from '../../container/AlertDownload';
import Footer from '../Footer';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'assessment.header.title',
    description: 'Page Header Title',
    defaultMessage: 'Analyzer Report'
  },
  headerSubTitle: {
    id: 'assessment.header.download.report',
    description: 'Page Header Subtitle',
    defaultMessage: 'Download Analyzer Report'
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

const print = status => {
  if (status.payload) {
    console.log(status.payload.response);
    return status.payload.response;
  }
};

class RDownload extends Component {
  componentWillMount() {
    console.log(this.props.reference_id);
    this.props.getRptInfobyreferenceid(this.props.reference_id);
  }

  componentWillMount() {
    this.props.getinfobyusernameandreferenceid(this.props.username,this.props.reference_id);
  }

  render() {
    return (
      <div className="preview page">
        <Helmet>
          <title>
            {this.props.intl.formatMessage(messages.htmlHeader)} - SHIFT
          </title>
        </Helmet>
        <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
          icon="preview"
          locale={this.props.locale}
        />

        <AlertDownload
          title="Report Download Error"
          body="Invalid Reference Id."
          message={print(this.props.status)}
        />

        <div className="main">
          <div
            className="panel"
            style={{
              width: '60%',
              padding: '40px',
              boxSizing: 'content-box',
              marginTop: '15px',
              display: 'block',
              alignContent: 'center',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            <LocalForm
              className="form"
              onSubmit={({ reference_id }) =>
                this.props.clickSubmitHandler(reference_id)
              }
            >
              <div
                style={{
                  marginLeft: '3%'
                }}
              >
                <fieldset>
                  <label style={{ textTransform: 'capitalize' }}>
                    <FormattedMessage
                      id="translationapproval.reference.id"
                      defaultMessage="Reference ID: "
                    />
                  </label>

                  <Control.text
                    model=".reference_id"
                    defaultValue={this.props.reference_id}
                    disabled
                    autoFocus
                    required
                  ></Control.text>
                </fieldset>

                <fieldset>
                  <label style={{ textTransform: 'capitalize' }}>
                    <FormattedMessage
                      id="snowflake.form.title"
                      defaultMessage="Client/Prospect Name: "
                    />
                  </label>
                  <Control.text
                    model=".clientname"
                    value={this.props.clientname}
                    disabled
                    autoFocus
                    required
                  />
                </fieldset>

                <fieldset>
                  <label style={{ textTransform: 'capitalize' }}>
                    <FormattedMessage
                      id="projects.project.source-language"
                      defaultMessage="Source Language: "
                    />
                  </label>
                  <Control.text
                    model=".srclang"
                    value={this.props.srclang}
                    disabled
                    autoFocus
                    required
                  ></Control.text>
                </fieldset>

                <fieldset>
                  <label style={{ textTransform: 'capitalize' }}>
                    <FormattedMessage
                      id="comments.name"
                      defaultMessage="Description "
                    />
                  </label>
                  <Control.text
                    model=".description"
                    value={this.props.description}
                    disabled
                    autoFocus
                  />
                </fieldset>

                <div
                  className="button-container"
                  style={{ textAlign: 'center' }}
                >
                  <button
                    className="button"
                    type="button"
                    style={{ marginRight: '40px' }}
                    onClick={() => this.props.clickBackHandler()}
                  >
                    <FormattedMessage
                      id="run-assessment.back.button.name"
                      defaultMessage="Back"
                    />
                  </button>

                  <button className="button" type="submit">
                    <FormattedMessage
                      id="download.button.name"
                      defaultMessage="Download"
                    />
                  </button>
                </div>
              </div>
            </LocalForm>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

RDownload.propTypes = {
  clickSubmitHandler: PropTypes.func.isRequired,
  getRptInfobyreferenceid: PropTypes.func.isRequired,
  getinfobyusernameandreferenceid: PropTypes.func.isRequired,
  locale: PropTypes.string,
  intl: PropTypes.object,
  status: PropTypes.object,
  reference_id: PropTypes.string,
  clientname: PropTypes.string,
  srclang: PropTypes.string,
  description: PropTypes.string
};

export default injectIntl(RDownload);



// WEBPACK FOOTER //
// ./src/components/views/RDownload/index.js